// `station.unpair` — the PC is no longer this station's (ADR-0057; spec/09 §6.2, spec/10 §3.2, spec/13 §12).
//
// Staff unpair a station (`POST …/stations/{s}/unpair`) to pair a different PC to it, or remove the station
// (`POST …/stations/{s}/remove`). Either way the api revokes the PC's device key at once (its next token is refused,
// spec/07 §5) and sends this command to the station. The station
//
//   - answers `ok: true` within the ack window (spec/09 §5.1);
//   - forgets the identity it was bound to (the device id, the station, the venue and the organisation it saved at
//     pairing) and the tokens it holds, and starts pairing again: it shows a fresh pairing code, ready for staff to pair
//     it to any station.
//
// It is sent while the PC is connected: the realtime token it already holds keeps its socket open long enough to take it.
// A PC that is offline when it is unpaired cannot take it later, because its key no longer authenticates; the command
// expires after its default 24 hours (ADR-0057 records this). Never sent while a session runs on the station: both
// routes refuse that with `409`.
import { z } from "../zod.js";
import { MemberIdSchema } from "../ids/schema.js";
/** The command type (spec/09 §6.2). Its default expiry is 24 hours (`STATION_COMMAND_EXPIRY_SECONDS`). */
export const STATION_UNPAIR = 'station.unpair';
/** Why the PC was unpaired: staff unpaired the station (it stays, waiting for a PC), or removed it. */
export const STATION_UNPAIR_REASONS = ['unpaired', 'removed'];
export const StationUnpairCommandPayloadSchema = z
    .object({
    /** The member who unpaired or removed the station (the audit row names them too). */
    by: MemberIdSchema,
    reason: z.enum(STATION_UNPAIR_REASONS),
})
    .openapi('StationUnpairCommandPayload', {
    description: '`station.unpair`: this PC is no longer paired to the station. Forget the saved identity and tokens and start pairing ' +
        'again, showing a fresh code (ADR-0057).',
});
//# sourceMappingURL=unpair.js.map